import { render, staticRenderFns } from "./ViewRiskListModal.vue?vue&type=template&id=51cde490&"
import script from "./ViewRiskListModal.vue?vue&type=script&lang=js&"
export * from "./ViewRiskListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports